import type { Office, LocationData } from "./types"
import { BRISTOL_OFFICES, BRISTOL_SPECIALISMS, BRISTOL_AREAS } from "./bristol"
import { BRIGHTON_OFFICES, BRIGHTON_SPECIALISMS, BRIGHTON_AREAS } from "./brighton"
import { BATH_OFFICES, BATH_SPECIALISMS, BATH_AREAS } from "./bath"
import { OXFORD_OFFICES, OXFORD_SPECIALISMS, OXFORD_AREAS } from "./oxford"

export type { Office, LocationData }

export const LOCATIONS: Record<string, LocationData> = {
  bristol: {
    slug: "bristol",
    name: "Bristol",
    description: "Top estate agents across Clifton, Redland, Bishopston, and more.",
    offices: BRISTOL_OFFICES,
    specialisms: BRISTOL_SPECIALISMS,
    areas: BRISTOL_AREAS,
  },
  brighton: {
    slug: "brighton",
    name: "Brighton",
    description: "Leading estate agents across Brighton, Hove, Kemptown, and beyond.",
    offices: BRIGHTON_OFFICES,
    specialisms: BRIGHTON_SPECIALISMS,
    areas: BRIGHTON_AREAS,
  },
  bath: {
    slug: "bath",
    name: "Bath",
    description: "Top estate agents across Bath's Georgian city centre, Lansdown, Bathwick, and beyond.",
    offices: BATH_OFFICES,
    specialisms: BATH_SPECIALISMS,
    areas: BATH_AREAS,
  },
  oxford: {
    slug: "oxford",
    name: "Oxford",
    description: "Leading estate agents across Summertown, Jericho, Headington, and more.",
    offices: OXFORD_OFFICES,
    specialisms: OXFORD_SPECIALISMS,
    areas: OXFORD_AREAS,
  },
}

export const LOCATION_SLUGS = Object.keys(LOCATIONS)

export function getLocationBySlug(slug: string): LocationData | undefined {
  return LOCATIONS[slug]
}

export function getOfficeBySlug(locationSlug: string, officeSlug: string): Office | undefined {
  const location = LOCATIONS[locationSlug]
  if (!location) return undefined
  return location.offices.find((o) => o.slug === officeSlug)
}

export function getOfficesBySlugs(locationSlug: string, officeSlugs: string[]): Office[] {
  const location = LOCATIONS[locationSlug]
  if (!location) return []
  return officeSlugs
    .map((s) => location.offices.find((o) => o.slug === s))
    .filter(Boolean) as Office[]
}

export function getAllOfficeSlugsForLocation(locationSlug: string): string[] {
  const location = LOCATIONS[locationSlug]
  if (!location) return []
  return location.offices.map((o) => o.slug)
}
